module.exports = __webpack_public_path__ + "img/signin_icon__avatar_teacher_normal.95078797.png";